module.exports = __webpack_public_path__ + "static/media/customModal.cd22321c.jpg";